import {selectIsSempCabinet} from 'src/utils/personalAccountSettings'

export function selectCanUseSellerRegistries(state) {
  const endpointId = state?.endpoint?.selectedEndpoint?.id
  if (!endpointId) return false

  const permission = state?.user?.permissions?.endpoints?.[endpointId]
  return permission?.is_seller_registry_creator === true
    && selectIsSempCabinet(state, endpointId)
}

export function sellerRegistryRouteDecision(state) {
  const permissions = state?.user?.permissions
  const endpointId = state?.endpoint?.selectedEndpoint?.id
  if (!permissions || (!endpointId && state?.user?.loading)) return 'loading'
  return selectCanUseSellerRegistries(state) ? 'allow' : 'redirect'
}

export function registryBelongsToEndpoint(registry, endpointId) {
  const registryEndpointId = registry?.endpoint?.id ?? registry?.endpoint
  return registry != null && endpointId != null
    && String(registryEndpointId) === String(endpointId)
}
